import { render, staticRenderFns } from "./terms-short.vue?vue&type=template&id=9c0ea9f4&"
import script from "./terms-short.vue?vue&type=script&lang=js&"
export * from "./terms-short.vue?vue&type=script&lang=js&"
import style0 from "./terms-short.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports